import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Route, Link, Routes, Navigate, Switch, HashRouter} from 'react-router-dom';
import './index.css';
import App from './App';
import reportWebVitals from './pages/reportWebVitals';
import Home from './Home';
import About from './About';
import Contact from './Contact';
import ManpowerOutsourcing from './ManpowerOutsourcing';
import ThirdPartyPayroll from './ThirdPartyPayroll';
import PerformanceBased from './PerformanceBased';
import ContractualWorkforceSolutions from './ContractualWorkforceSolutions';
import Mission from './pages/Misson';
import CandidateServicesNew from './Candidate-Services';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  
  <BrowserRouter>
  <Routes>
      <Route path="/" element={<Home />} /> 
      <Route path="/about" element={<About />} /> 
      <Route path="/contact" element={<Contact />} /> 
      <Route path="/outsourcing" element={<ManpowerOutsourcing />} /> 
      <Route path="/third-party-payroll" element={<ThirdPartyPayroll />} /> 
      <Route path="/performance-based" element={<PerformanceBased  />} /> 
      <Route path="/contractual-workforce-solutions" element={<ContractualWorkforceSolutions  />} /> 
      <Route path="/candidate-services" element={<CandidateServicesNew/>} /> 
      <Route path="/candidate-services-New" element={<Mission  />} /> 
       {/* <Route path="/directors" element={<Director />} /> 
      <Route path="/mission-vission" element={<Mission />} /> 
     <Route path="/career" element={<Career />} /> 
      <Route path="/products" element={<Products />} /> 
      <Route path="/terms" element={<Terms />} /> 
      <Route path="/privacy" element={<Privacy />} /> 
      <Route path="/login" element={<Login />} /> 
      <Route path="/leads" element={<Leadlist />} /> 
      <Route path="/gallery" element={<Gallery />} />  */}
      
  </Routes>
</BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
